import { useEffect, useRef, useState } from 'react'

export default function Select({
    value,
    options = [],
    onChange = () => {},
    placeholder = 'Select…',
    disabled = false,
    className = '',
    width = '100%'
}) {
    const [open, setOpen] = useState(false)
    const btnRef = useRef(null)
    const popRef = useRef(null)

    const current = options.find(o => String(o.value) === String(value))
    const label = current ? current.label : placeholder

    useEffect(() => {
        if (!open) return
        const onDoc = (e) => {
            if (btnRef.current?.contains(e.target)) return
            if (popRef.current?.contains(e.target)) return
            setOpen(false)
        }
        document.addEventListener('mousedown', onDoc)
        return () => document.removeEventListener('mousedown', onDoc)
    }, [open])

    const handleChange = (val) => {
        const n = Number(val)
        onChange(Number.isNaN(n) ? val : n)
    }

    return (
        <div className={`select ${className} ${disabled?'is-disabled':''}`} style={{ width }}>
            <button
                type="button"
                ref={btnRef}
                className="select-btn"
                disabled={disabled}
                aria-expanded={open}
                onClick={()=>setOpen(o=>!o)}

            >
                <span className={`select-label ${current ? '' : 'placeholder'}`}>{label}</span>
                <span className={`select-caret ${open?'up':''}`}>▾</span>
            </button>
            {open && (
                <div ref={popRef} className="select-menu" role="listbox">
                    {options.map(opt => {
                        const active = String(opt.value) === String(value)
                        return (
                            <button
                                key={String(opt.value)}
                                type="button"
                                className={`select-item ${active?'active':''}`}
                                role="option"
                                aria-selected={active}
                                onClick={()=>{
                                    handleChange(opt.value)
                                    setOpen(false)
                                }}
                            >
                                <span className="select-item-label">{opt.label}</span>
                                {active && <span className="check">✓</span>}
                            </button>
                        )
                    })}
                </div>
            )}
        </div>
    )
}
